// import firebase from "firebase";
import { OlabItem } from "../olab/olabitem.js";
import { OlabGene } from "../olab/olabgene.js";
import { OlabCart } from "../olab/olabcart.js";
import { OlabProject } from "../olab/olabproject.js";
import { OlabPackage } from "../olab/olabpackage.js";
import { OlabSequence } from "../olab/olabsequence.js";
import { OlabUtils } from "./olabutils.js";
import db from "../olab/db.js";
import _ from "lodash";

class OlabSearch {
  // 10 counts per page
  static cntPerPage = 10;

  constructor() {
    OlabUtils.infoLog("OlabSearch.constructor() ...");
    this.ref = null;
    this.lastStopRec = null;
  }

  static searchTermStopAt(sTerm) {
    let sTermCp = new String(sTerm);
    let lastChar = sTermCp.substring(sTermCp.length - 1, sTermCp.length);
    sTermCp = sTermCp.substring(0, sTermCp.length - 1);
    let lastAddOne = String.fromCharCode(lastChar.charCodeAt(0) + 1);
    // OlabUtils.infoLog(
    //   "sTermCp = " +
    //   sTermCp +
    //   ", lastChar = " +
    //   lastChar +
    //   ", lastChar+1 = " +
    //   lastAddOne
    // );
    let sTermStopAt = sTermCp + lastAddOne;
    // OlabUtils.infoLog("sTerm = " + sTerm + ", sTermStopAt = " + sTermStopAt);
    return sTermStopAt;
  }

  static initSelected(selected) {
    // selected.genes = null;
    // selected.items = null;
    selected.collectionRef = null;
    selected.collectionOrderBy = "olab_id";
    selected.pageNumber = 1;
    selected.nextRecRef = null;
    selected.nextIsDisabled = true;
    // This is an array of prev page refs
    selected.prevRecRefArr = [];
    selected.prevIsDisabled = true;
  }

  static getFieldVal(selected, prevRef) {
    const recRef = prevRef ? prevRef : selected.nextRecRef;
    switch (selected.collectionOrderBy) {
      case "olab_id":
        return recRef.olab_id;
      case "name_uc":
        return recRef.name_uc;
      case "synonym_name1_uc":
        return recRef.synonym_name1_uc;
      case "synonym_name2_uc":
        return recRef.synonym_name2_uc;
      case "synonym_name3_uc":
        return recRef.synonym_name3_uc;
      case "synonym_name4_uc":
        return recRef.synonym_name4_uc;
      case "synonym_name5_uc":
        return recRef.synonym_name5_uc;
      case "locus_tag":
        return recRef.locus_tag;
      case "old_locus_tag_uc":
        return recRef.old_locus_tag_uc;
      case "sequence.seq":
        return recRef.sequence.seq;
      case "creator_uc":
        return recRef.creator_uc;
      case "seq":
        return recRef.seq;
    }

    // default value
    return recRef.olab_id;
  }

  static doPrev(selectedType, selected) {
    OlabUtils.infoLog("** doPrev - selectedType = " + selectedType);

    const prevRef = selected.prevRecRefArr.pop();
    selected.pageNumber--;
    if (selected.prevRecRefArr.length <= 0) {
      selected.prevIsDisabled = true;
    }
    if (prevRef == null) {
      return;
    }

    let converter = OlabItem.getOlabItemConverter();
    if (selectedType == "genome") {
      converter = OlabGene.getOlabGeneConverter();
    } else if (selectedType == "cart") {
      converter = OlabCart.getOlabCartConverter();
    }

    const fieldVal = OlabSearch.getFieldVal(selected, prevRef);
    selected.collectionRef
      .orderBy(selected.collectionOrderBy)
      .startAt(fieldVal)
      .withConverter(converter)
      .limit(OlabSearch.cntPerPage)
      .get()
      .then(
        function(querySnapshot) {
          const snapArr = [];
          querySnapshot.forEach(function(doc) {
            // OlabUtils.infoLog(doc.id + " => " + doc.data());
            snapArr.push(doc.data());
          });
          if (snapArr.length >= OlabSearch.cntPerPage) {
            selected.nextRecRef = snapArr[snapArr.length - 1];
            selected.nextIsDisabled = false;
            OlabUtils.infoLog(
              "selected.nextRecRef.olab_id = " + selected.nextRecRef.olab_id
            );
          } else {
            // No more data for next page
            selected.nextRecRef = null;
            selected.nextIsDisabled = true;
          }
          OlabUtils.infoLog("snapArr.len = " + snapArr.length);
          if (selectedType == "genome") {
            selected.genes = snapArr;
          } else {
            selected.items = snapArr;
          }
        }.bind(this)
      );
  }

  static doNext(selectedType, selected) {
    OlabUtils.infoLog("** doNext - selectedType = " + selectedType);

    // Set Prev reference
    if (selectedType == "genome") {
      selected.prevRecRefArr.push(selected.genes[0]);
    } else {
      selected.prevRecRefArr.push(selected.items[0]);
    }
    selected.pageNumber++;
    selected.prevIsDisabled = false;

    let converter = OlabItem.getOlabItemConverter();
    if (selectedType == "genome") {
      converter = OlabGene.getOlabGeneConverter();
    } else if (selectedType == "cart") {
      converter = OlabCart.getOlabCartConverter();
    }

    const fieldVal = OlabSearch.getFieldVal(selected, null);
    selected.collectionRef
      .orderBy(selected.collectionOrderBy)
      .startAfter(fieldVal)
      .withConverter(converter)
      .limit(OlabSearch.cntPerPage)
      .get()
      .then(
        function(querySnapshot) {
          const snapArr = [];
          querySnapshot.forEach(function(doc) {
            // OlabUtils.infoLog(doc.id + " => " + doc.data());
            snapArr.push(doc.data());
          });
          if (snapArr.length >= OlabSearch.cntPerPage) {
            selected.nextRecRef = snapArr[snapArr.length - 1];
            selected.nextIsDisabled = false;
            OlabUtils.infoLog(
              "selected.nextRecRef.olab_id = " + selected.nextRecRef.olab_id
            );
          } else {
            // No more data for next page
            selected.nextRecRef = null;
            selected.nextIsDisabled = true;
          }
          OlabUtils.infoLog("snapArr.len = " + snapArr.length);
          if (selectedType == "genome") {
            selected.genes = snapArr;
          } else {
            selected.items = snapArr;
          }
        }.bind(this)
      );
  }

  static doSearchTerm(sTerm, sType, filterKey, geneCollectionStr, selected) {
    // Initialize selected at the beginning of a new sTerm
    OlabSearch.initSelected(selected);

    // Limit sTerm to Firebase limit of about 1400 chars
    if (sTerm && sTerm.length > 1400) {
      sTerm = sTerm.substr(0, 1400);
    }

    if (sType === "genome") {
      OlabSearch.searchGenes(sTerm, filterKey, geneCollectionStr, selected);
    } else if (sType === "cart") {
      OlabSearch.searchCarts(sTerm, filterKey, selected);
    } else {
      OlabSearch.searchItems(sTerm, sType, filterKey, selected);
    }
  }

  static searchGenesBlank(genesRef, selected) {
    OlabUtils.infoLog("*** searchGenesBlank ***");

    genesRef
      .where("olab_id", ">=", "")
      .limit(OlabSearch.cntPerPage)
      .withConverter(OlabGene.getOlabGeneConverter())
      .get()
      .then(
        function(querySnapshot) {
          const snapArr = [];
          querySnapshot.forEach(function(doc) {
            // OlabUtils.infoLog(doc.id + " => " + doc.data());
            snapArr.push(doc.data());
          });
          if (snapArr.length >= OlabSearch.cntPerPage) {
            selected.collectionRef = genesRef;
            selected.collectionOrderBy = "olab_id";
            selected.nextRecRef = snapArr[snapArr.length - 1];
            selected.nextIsDisabled = false;
            OlabUtils.infoLog(
              "selected.nextRecRef.olab_id = " + selected.nextRecRef.olab_id
            );
          }
          OlabUtils.infoLog("snapArr.len = " + snapArr.length);
          selected.genes = snapArr;
        }.bind(this)
      );
  }

  static createIDsRef(genesRef, searchName, nsTerm, sTermSA) {
    return genesRef
      .where(searchName, ">=", nsTerm)
      .where(searchName, "<", sTermSA);
  }

  static createIDs(idsRef, olabGeneConverter) {
    return idsRef
      .limit(OlabSearch.cntPerPage)
      .withConverter(olabGeneConverter)
      .get();
  }

  // This search gene by name also include synonym_name
  static async searchGeneName(sTerm, genesRef, selected) {
    // Default search will be done with uppercase
    let nsTerm = sTerm.toUpperCase();
    let sTermSA = OlabSearch.searchTermStopAt(nsTerm);
    OlabUtils.infoLog(
      "searchGeneName - nsTerm = " + nsTerm + ", sTermSA = " + sTermSA
    );

    const olabGeneConverter = OlabGene.getOlabGeneConverter();

    const nameIDsRef = OlabSearch.createIDsRef(
      genesRef,
      "name_uc",
      nsTerm,
      sTermSA
    );
    const nameIDs = OlabSearch.createIDs(nameIDsRef, olabGeneConverter);

    const sName1IDsRef = OlabSearch.createIDsRef(
      genesRef,
      "synonym_name1_uc",
      nsTerm,
      sTermSA
    );
    const sName1IDs = OlabSearch.createIDs(sName1IDsRef, olabGeneConverter);
    const sName2IDsRef = OlabSearch.createIDsRef(
      genesRef,
      "synonym_name2_uc",
      nsTerm,
      sTermSA
    );
    const sName2IDs = OlabSearch.createIDs(sName2IDsRef, olabGeneConverter);
    const sName3IDsRef = OlabSearch.createIDsRef(
      genesRef,
      "synonym_name3_uc",
      nsTerm,
      sTermSA
    );
    const sName3IDs = OlabSearch.createIDs(sName3IDsRef, olabGeneConverter);
    const sName4IDsRef = OlabSearch.createIDsRef(
      genesRef,
      "synonym_name4_uc",
      nsTerm,
      sTermSA
    );
    const sName4IDs = OlabSearch.createIDs(sName4IDsRef, olabGeneConverter);
    const sName5IDsRef = OlabSearch.createIDsRef(
      genesRef,
      "synonym_name5_uc",
      nsTerm,
      sTermSA
    );
    const sName5IDs = OlabSearch.createIDs(sName5IDsRef, olabGeneConverter);

    const [
      nameIDsSnapShot,
      sName1IDsSnapShot,
      sName2IDsSnapShot,
      sName3IDsSnapShot,
      sName4IDsSnapShot,
      sName5IDsSnapShot
    ] = await Promise.all([
      nameIDs,
      sName1IDs,
      sName2IDs,
      sName3IDs,
      sName4IDs,
      sName5IDs
    ]);
    const nameIDsArray = nameIDsSnapShot.docs;
    const sName1IDsArray = sName1IDsSnapShot.docs;
    const sName2IDsArray = sName2IDsSnapShot.docs;
    const sName3IDsArray = sName3IDsSnapShot.docs;
    const sName4IDsArray = sName4IDsSnapShot.docs;
    const sName5IDsArray = sName5IDsSnapShot.docs;

    let maxRef = nameIDsRef;
    let maxArr = nameIDsArray;
    let maxOrderBy = "name_uc";
    if (sName1IDsArray.length > maxArr.length) {
      // OlabUtils.infoLog("sName1IDsArray.length = " + sName1IDsArray.length);
      maxRef = sName1IDsRef;
      maxArr = sName1IDsArray;
      maxOrderBy = "synonym_name1_uc";
    }
    if (sName2IDsArray.length > maxArr.length) {
      // OlabUtils.infoLog("sName2IDsArray.length = " + sName2IDsArray.length);
      maxRef = sName2IDsRef;
      maxArr = sName2IDsArray;
      maxOrderBy = "synonym_name2_uc";
    }
    if (sName3IDsArray.length > maxArr.length) {
      // OlabUtils.infoLog("sName3IDsArray.length = " + sName3IDsArray.length);
      maxRef = sName3IDsRef;
      maxArr = sName3IDsArray;
      maxOrderBy = "synonym_name3_uc";
    }
    if (sName4IDsArray.length > maxArr.length) {
      // OlabUtils.infoLog("sName4IDsArray.length = " + sName4IDsArray.length);
      maxRef = sName4IDsRef;
      maxArr = sName4IDsArray;
      maxOrderBy = "synonym_name4_uc";
    }
    if (sName5IDsArray.length > maxArr.length) {
      // OlabUtils.infoLog("sName5IDsArray.length = " + sName5IDsArray.length);
      maxRef = sName5IDsRef;
      maxArr = sName5IDsArray;
      maxOrderBy = "synonym_name5_uc";
    }
    let combinedArray = _.concat(
      nameIDsArray,
      sName1IDsArray,
      sName2IDsArray,
      sName3IDsArray,
      sName4IDsArray,
      sName5IDsArray
    );
    combinedArray = _.uniqWith(combinedArray, _.isEqual);

    const snapArr = [];
    combinedArray.forEach(function(doc) {
      // OlabUtils.infoLog(doc.id + " => " + doc.data());
      snapArr.push(doc.data());
    });
    // Setup Next reference
    if (snapArr.length >= OlabSearch.cntPerPage) {
      selected.collectionRef = maxRef;
      selected.collectionOrderBy = maxOrderBy;
      selected.nextRecRef = snapArr[snapArr.length - 1];
      selected.nextIsDisabled = false;
      OlabUtils.infoLog(
        "selected.nextRecRef.olab_id = " + selected.nextRecRef.olab_id
      );
    }
    OlabUtils.infoLog("snapArr.len = " + snapArr.length);
    selected.genes = snapArr;
  }

  static async searchGenes(sTerm, sFilter, collectionStr, selected) {
    const genesRef = collectionStr
      ? db.collection(collectionStr)
      : db.collectionGroup("olab_genes");

    if (sTerm == "") {
      OlabUtils.infoLog("searchGenes - sTerm = " + sTerm);
      OlabSearch.searchGenesBlank(genesRef, selected);
    } else if (sFilter === "merge") {
      // Default search will be done with uppercase
      let nsTerm = sTerm.toUpperCase();
      let sTermSA = OlabSearch.searchTermStopAt(nsTerm);
      OlabUtils.infoLog(
        "searchGenes - nsTerm = " + nsTerm + ", sTermSA = " + sTermSA
      );

      const olabGeneConverter = OlabGene.getOlabGeneConverter();

      const olabIDsRef = OlabSearch.createIDsRef(
        genesRef,
        "olab_id",
        nsTerm,
        sTermSA
      );
      const olabIDs = OlabSearch.createIDs(olabIDsRef, olabGeneConverter);

      const nameIDsRef = OlabSearch.createIDsRef(
        genesRef,
        "name_uc",
        nsTerm,
        sTermSA
      );
      const nameIDs = OlabSearch.createIDs(nameIDsRef, olabGeneConverter);

      const sName1IDsRef = OlabSearch.createIDsRef(
        genesRef,
        "synonym_name1_uc",
        nsTerm,
        sTermSA
      );
      const sName1IDs = OlabSearch.createIDs(sName1IDsRef, olabGeneConverter);
      const sName2IDsRef = OlabSearch.createIDsRef(
        genesRef,
        "synonym_name2_uc",
        nsTerm,
        sTermSA
      );
      const sName2IDs = OlabSearch.createIDs(sName2IDsRef, olabGeneConverter);
      const sName3IDsRef = OlabSearch.createIDsRef(
        genesRef,
        "synonym_name3_uc",
        nsTerm,
        sTermSA
      );
      const sName3IDs = OlabSearch.createIDs(sName3IDsRef, olabGeneConverter);
      const sName4IDsRef = OlabSearch.createIDsRef(
        genesRef,
        "synonym_name4_uc",
        nsTerm,
        sTermSA
      );
      const sName4IDs = OlabSearch.createIDs(sName4IDsRef, olabGeneConverter);
      const sName5IDsRef = OlabSearch.createIDsRef(
        genesRef,
        "synonym_name5_uc",
        nsTerm,
        sTermSA
      );
      const sName5IDs = OlabSearch.createIDs(sName5IDsRef, olabGeneConverter);

      const bNumIDsRef = OlabSearch.createIDsRef(
        genesRef,
        "b_number_uc",
        nsTerm,
        sTermSA
      );
      const bNumIDs = OlabSearch.createIDs(bNumIDsRef, olabGeneConverter);

      const locusTagIDsRef = OlabSearch.createIDsRef(
        genesRef,
        "locus_tag",
        nsTerm,
        sTermSA
      );
      const locusTagIDs = OlabSearch.createIDs(
        locusTagIDsRef,
        olabGeneConverter
      );
      const oldLocusTagIDsRef = OlabSearch.createIDsRef(
        genesRef,
        "old_locus_tag_uc",
        nsTerm,
        sTermSA
      );
      const oldLocusTagIDs = OlabSearch.createIDs(
        oldLocusTagIDsRef,
        olabGeneConverter
      );

      const seqIDsRef = OlabSearch.createIDsRef(
        genesRef,
        "sequence.seq",
        nsTerm,
        sTermSA
      );
      const seqIDs = OlabSearch.createIDs(seqIDsRef, olabGeneConverter);

      const [
        olabIDsSnapShot,
        nameIDsSnapShot,
        sName1IDsSnapShot,
        sName2IDsSnapShot,
        sName3IDsSnapShot,
        sName4IDsSnapShot,
        sName5IDsSnapShot,
        bNumIDsSnapShot,
        locusTagIDsSnapShot,
        oldLocusTagIDsSnapShot,
        seqIDsSnapShot
      ] = await Promise.all([
        olabIDs,
        nameIDs,
        sName1IDs,
        sName2IDs,
        sName3IDs,
        sName4IDs,
        sName5IDs,
        bNumIDs,
        locusTagIDs,
        oldLocusTagIDs,
        seqIDs
      ]);

      const olabIDsArray = olabIDsSnapShot.docs;
      const nameIDsArray = nameIDsSnapShot.docs;
      const sName1IDsArray = sName1IDsSnapShot.docs;
      const sName2IDsArray = sName2IDsSnapShot.docs;
      const sName3IDsArray = sName3IDsSnapShot.docs;
      const sName4IDsArray = sName4IDsSnapShot.docs;
      const sName5IDsArray = sName5IDsSnapShot.docs;
      const bNumIDsArray = bNumIDsSnapShot.docs;
      const locusTagIDsArray = locusTagIDsSnapShot.docs;
      const oldLocusTagIDsArray = oldLocusTagIDsSnapShot.docs;
      const seqIDsArray = seqIDsSnapShot.docs;

      let maxRef = olabIDsRef;
      let maxArr = olabIDsArray;
      let maxOrderBy = "olab_id";
      // OlabUtils.infoLog("olabIDsArray.length = " + olabIDsArray.length);

      if (nameIDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("nameIDsArray.length = " + nameIDsArray.length);
        maxRef = nameIDsRef;
        maxArr = nameIDsArray;
        maxOrderBy = "name_uc";
      }
      if (sName1IDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("sName1IDsArray.length = " + sName1IDsArray.length);
        maxRef = sName1IDsRef;
        maxArr = sName1IDsArray;
        maxOrderBy = "synonym_name1_uc";
      }
      if (sName2IDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("sName2IDsArray.length = " + sName2IDsArray.length);
        maxRef = sName2IDsRef;
        maxArr = sName2IDsArray;
        maxOrderBy = "synonym_name2_uc";
      }
      if (sName3IDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("sName3IDsArray.length = " + sName3IDsArray.length);
        maxRef = sName3IDsRef;
        maxArr = sName3IDsArray;
        maxOrderBy = "synonym_name3_uc";
      }
      if (sName4IDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("sName4IDsArray.length = " + sName4IDsArray.length);
        maxRef = sName4IDsRef;
        maxArr = sName4IDsArray;
        maxOrderBy = "synonym_name4_uc";
      }
      if (sName5IDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("sName5IDsArray.length = " + sName5IDsArray.length);
        maxRef = sName5IDsRef;
        maxArr = sName5IDsArray;
        maxOrderBy = "synonym_name5_uc";
      }
      if (bNumIDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("bNumIDsArray.length = " + bNumIDsArray.length);
        maxRef = bNumIDsRef;
        maxArr = bNumIDsArray;
        maxOrderBy = "b_number_uc";
      }
      if (locusTagIDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("locusTagIDsArray.length = " + locusTagIDsArray.length);
        maxRef = locusTagIDsRef;
        maxArr = locusTagIDsArray;
        maxOrderBy = "locus_tag";
      }
      if (oldLocusTagIDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("oldLocusTagIDsArray.length = " + oldLocusTagIDsArray.length);
        maxRef = oldLocusTagIDsRef;
        maxArr = oldLocusTagIDsArray;
        maxOrderBy = "old_locus_tag_uc";
      }
      if (seqIDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("seqIDsArray.length = " + seqIDsArray.length);
        maxRef = seqIDsRef;
        maxArr = seqIDsArray;
        maxOrderBy = "sequence.seq";
      }

      let combinedArray = _.concat(
        olabIDsArray,
        nameIDsArray,
        sName1IDsArray,
        sName2IDsArray,
        sName3IDsArray,
        sName4IDsArray,
        sName5IDsArray,
        bNumIDsArray,
        locusTagIDsArray,
        oldLocusTagIDsArray,
        seqIDsArray
      );
      combinedArray = _.uniqWith(combinedArray, _.isEqual);

      const snapArr = [];
      combinedArray.forEach(function(doc) {
        // OlabUtils.infoLog(doc.id + " => " + doc.data());
        snapArr.push(doc.data());
      });
      // Setup Next reference
      if (snapArr.length >= OlabSearch.cntPerPage) {
        selected.collectionRef = maxRef;
        selected.collectionOrderBy = maxOrderBy;
        selected.nextRecRef = snapArr[snapArr.length - 1];
        selected.nextIsDisabled = false;
        OlabUtils.infoLog(
          "selected.nextRecRef.olab_id = " + selected.nextRecRef.olab_id
        );
      }
      OlabUtils.infoLog("snapArr.len = " + snapArr.length);
      selected.genes = snapArr;
    } else if (sFilter === "name") {
      OlabUtils.infoLog("calling searchGeneName - sTerm = " + sTerm);
      OlabSearch.searchGeneName(sTerm, genesRef, selected);
    } else {
      // Default search will be done with uppercase
      let nsTerm = sTerm.toUpperCase();
      let filterField = "olab_id";
      if (sFilter === "name") {
        filterField = "name_uc";
      } else if (sFilter === "b_number") {
        filterField = "b_number_uc";
      } else if (sFilter === "locus_tag") {
        filterField = "locus_tag";
      } else if (sFilter === "old_locus_tag") {
        filterField = "old_locus_tag_uc";
      } else if (sFilter === "seq") {
        filterField = "sequence.seq";
      }

      let sTermSA = OlabSearch.searchTermStopAt(nsTerm);
      OlabUtils.infoLog("nsTerm = " + nsTerm + ", sTermSA = " + sTermSA);

      const gRef = genesRef
        .where(filterField, ">=", nsTerm)
        .where(filterField, "<", sTermSA);
      gRef
        .limit(OlabSearch.cntPerPage)
        .withConverter(OlabGene.getOlabGeneConverter())
        .get()
        .then(
          function(querySnapshot) {
            const snapArr = [];
            querySnapshot.forEach(function(doc) {
              // OlabUtils.infoLog(doc.id + " => " + doc.data());
              snapArr.push(doc.data());
            });
            if (snapArr.length >= OlabSearch.cntPerPage) {
              selected.collectionRef = gRef;
              selected.collectionOrderBy = filterField;
              selected.nextRecRef = snapArr[snapArr.length - 1];
              selected.nextIsDisabled = false;
              OlabUtils.infoLog(
                "selected.nextRecRef.olab_id = " + selected.nextRecRef.olab_id
              );
            }
            OlabUtils.infoLog("snapArr.len = " + snapArr.length);
            selected.genes = snapArr;
          }.bind(this)
        );
    }
  }

  static searchItemsBlank(sType, selected) {
    OlabUtils.infoLog(
      "searchItemsBlank: sType = " + sType + ", selected = " + selected
    );
    const itemsRef = db
      .collectionGroup("olab_items")
      .where("olab_type", "==", sType)
      .where("olab_id", ">=", "");

    itemsRef
      .limit(OlabSearch.cntPerPage)
      .withConverter(OlabItem.getOlabItemConverter())
      .get()
      .then(
        function(querySnapshot) {
          const snapArr = [];
          querySnapshot.forEach(function(doc) {
            // OlabUtils.infoLog(doc.id + " => " + doc.data());
            snapArr.push(doc.data());
          });
          if (snapArr.length >= OlabSearch.cntPerPage) {
            selected.collectionRef = itemsRef;
            selected.collectionOrderBy = "olab_id";
            selected.nextRecRef = snapArr[snapArr.length - 1];
            selected.nextIsDisabled = false;
            OlabUtils.infoLog(
              "selected.nextRecRef.olab_id = " + selected.nextRecRef.olab_id
            );
          }
          OlabUtils.infoLog("snapArr.len = " + snapArr.length);
          selected.items = snapArr;
        }.bind(this)
      );
  }

  static async searchItems(sTerm, sType, sFilter, selected) {
    if (sTerm == "") {
      OlabUtils.infoLog(
        "searchItems - sTerm = " + sTerm + ", sType = " + sType
      );
      OlabSearch.searchItemsBlank(sType, selected);
    } else if (sFilter === "merge") {
      // Default search will be done with uppercase
      let nsTerm = sTerm.toUpperCase();
      let sTermSA = OlabSearch.searchTermStopAt(nsTerm);
      OlabUtils.infoLog(
        "searchItems - nsTerm = " + nsTerm + ", sTermSA = " + sTermSA
      );
      const genesRef = db.collectionGroup("olab_items");
      const olabItemConverter = OlabItem.getOlabItemConverter();

      const olabIDsRef = genesRef
        .where("olab_type", "==", sType)
        .where("olab_id", ">=", nsTerm)
        .where("olab_id", "<", sTermSA);
      const olabIDs = olabIDsRef
        .limit(OlabSearch.cntPerPage)
        .withConverter(olabItemConverter)
        .get();

      const nameIDsRef = genesRef
        .where("olab_type", "==", sType)
        .where("name_uc", ">=", nsTerm)
        .where("name_uc", "<", sTermSA);
      const nameIDs = nameIDsRef
        .limit(OlabSearch.cntPerPage)
        .withConverter(olabItemConverter)
        .get();

      const creatorIDsRef = genesRef
        .where("olab_type", "==", sType)
        .where("creator_uc", ">=", nsTerm)
        .where("creator_uc", "<", sTermSA);
      const creatorIDs = creatorIDsRef
        .limit(OlabSearch.cntPerPage)
        .withConverter(olabItemConverter)
        .get();

      const seqIDsRef = genesRef
        .where("olab_type", "==", sType)
        .where("seq", ">=", nsTerm)
        .where("seq", "<", sTermSA);
      const seqIDs = seqIDsRef
        .limit(OlabSearch.cntPerPage)
        .withConverter(olabItemConverter)
        .get();

      const [
        olabIDsSnapShot,
        nameIDsSnapShot,
        creatorIDsSnapShot,
        seqIDsSnapShot
      ] = await Promise.all([olabIDs, nameIDs, creatorIDs, seqIDs]);

      const olabIDsArray = olabIDsSnapShot.docs;
      const nameIDsArray = nameIDsSnapShot.docs;
      const creatorIDsArray = creatorIDsSnapShot.docs;
      const seqIDsArray = seqIDsSnapShot.docs;

      let maxRef = olabIDsRef;
      let maxArr = olabIDsArray;
      let maxOrderBy = "olab_id";
      // OlabUtils.infoLog("olabIDsArray.length = " + olabIDsArray.length);

      if (nameIDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("nameIDsArray.length = " + nameIDsArray.length);
        maxRef = nameIDsRef;
        maxArr = nameIDsArray;
        maxOrderBy = "name_uc";
      }
      if (creatorIDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("creatorIDsArray.length = " + creatorIDsArray.length);
        maxRef = creatorIDsRef;
        maxArr = creatorIDsArray;
        maxOrderBy = "creator_uc";
      }
      if (seqIDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("seqIDsArray.length = " + seqIDsArray.length);
        maxRef = seqIDsRef;
        maxArr = seqIDsArray;
        maxOrderBy = "seq";
      }

      let combinedArray = _.concat(
        olabIDsArray,
        nameIDsArray,
        creatorIDsArray,
        seqIDsArray
      );
      combinedArray = _.uniqWith(combinedArray, _.isEqual);

      const snapArr = [];
      combinedArray.forEach(function(doc) {
        // OlabUtils.infoLog(doc.id + " => " + doc.data());
        snapArr.push(doc.data());
      });
      // Setup Next reference
      if (snapArr.length >= OlabSearch.cntPerPage) {
        selected.collectionRef = maxRef;
        selected.collectionOrderBy = maxOrderBy;
        selected.nextRecRef = snapArr[snapArr.length - 1];
        selected.nextIsDisabled = false;
        OlabUtils.infoLog(
          "selected.nextRecRef.olab_id = " + selected.nextRecRef.olab_id
        );
      }
      OlabUtils.infoLog("snapArr.len = " + snapArr.length);
      selected.items = snapArr;
    } else {
      // Search will be done with uppercase
      let nsTerm = sTerm.toUpperCase();
      let filterField = "olab_id";
      if (sFilter === "name") {
        filterField = "name_uc";
      } else if (sFilter === "creator") {
        filterField = "creator_uc";
      } else if (sFilter === "seq") {
        filterField = "seq";
      }

      let sTermSA = OlabSearch.searchTermStopAt(nsTerm);
      OlabUtils.infoLog("nsTerm = " + nsTerm + ", sTermSA = " + sTermSA);

      const olabRef = db
        .collectionGroup("olab_items")
        .where("olab_type", "==", sType)
        .where(filterField, ">=", nsTerm)
        .where(filterField, "<", sTermSA);

      olabRef
        .limit(OlabSearch.cntPerPage)
        .withConverter(OlabItem.getOlabItemConverter())
        .get()
        .then(
          function(querySnapshot) {
            const snapArr = [];
            querySnapshot.forEach(function(doc) {
              // OlabUtils.infoLog(doc.id + " => " + doc.data());
              snapArr.push(doc.data());
            });
            if (snapArr.length >= OlabSearch.cntPerPage) {
              selected.collectionRef = olabRef;
              selected.collectionOrderBy = filterField;
              selected.nextRecRef = snapArr[snapArr.length - 1];
              selected.nextIsDisabled = false;
              OlabUtils.infoLog(
                "selected.nextRecRef.olab_id = " + selected.nextRecRef.olab_id
              );
            }
            OlabUtils.infoLog("snapArr.len = " + snapArr.length);
            selected.items = snapArr;
          }.bind(this)
        );
    }
  }

  static searchCartsBlank(selected) {
    OlabUtils.infoLog("searchCartsBlank");
    const itemsRef = db
      .collectionGroup("olab_carts")
      .where("olab_id", ">=", "");

    itemsRef
      .limit(OlabSearch.cntPerPage)
      .withConverter(OlabCart.getOlabCartConverter())
      .get()
      .then(
        function(querySnapshot) {
          const snapArr = [];
          querySnapshot.forEach(function(doc) {
            // OlabUtils.infoLog(doc.id, " => ", doc.data());
            snapArr.push(doc.data());
          });
          if (snapArr.length >= OlabSearch.cntPerPage) {
            selected.collectionRef = itemsRef;
            selected.collectionOrderBy = "olab_id";
            selected.nextRecRef = snapArr[snapArr.length - 1];
            selected.nextIsDisabled = false;
            OlabUtils.infoLog(
              "selected.nextRecRef.olab_id = " + selected.nextRecRef.olab_id
            );
          }
          OlabUtils.infoLog("snapArr.len = " + snapArr.length);
          selected.items = snapArr;
          OlabUtils.infoLog("selected.items len = " + selected.items.length);
        }.bind(this)
      );
  }

  static async searchCarts(sTerm, sFilter, selected) {
    if (sTerm == "") {
      OlabUtils.infoLog("searchCarts - sTerm = " + sTerm);
      OlabSearch.searchCartsBlank(selected);
    } else if (sFilter === "merge") {
      // Default search will be done with uppercase
      let nsTerm = sTerm.toUpperCase();
      let sTermSA = OlabSearch.searchTermStopAt(nsTerm);
      OlabUtils.infoLog(
        "searchCarts - nsTerm = " + nsTerm + ", sTermSA = " + sTermSA
      );
      const cartsRef = db.collectionGroup("olab_carts");
      const olabCartConverter = OlabCart.getOlabCartConverter();

      const olabIDsRef = cartsRef
        .where("olab_id", ">=", nsTerm)
        .where("olab_id", "<", sTermSA);
      const olabIDs = olabIDsRef
        .limit(OlabSearch.cntPerPage)
        .withConverter(olabCartConverter)
        .get();

      const nameIDsRef = cartsRef
        .where("name_uc", ">=", nsTerm)
        .where("name_uc", "<", sTermSA);
      const nameIDs = nameIDsRef
        .limit(OlabSearch.cntPerPage)
        .withConverter(olabCartConverter)
        .get();

      const creatorIDsRef = cartsRef
        .where("creator_uc", ">=", nsTerm)
        .where("creator_uc", "<", sTermSA);
      const creatorIDs = creatorIDsRef
        .limit(OlabSearch.cntPerPage)
        .withConverter(olabCartConverter)
        .get();

      const [
        olabIDsSnapShot,
        nameIDsSnapShot,
        creatorIDsSnapShot
      ] = await Promise.all([olabIDs, nameIDs, creatorIDs]);

      const olabIDsArray = olabIDsSnapShot.docs;
      const nameIDsArray = nameIDsSnapShot.docs;
      const creatorIDsArray = creatorIDsSnapShot.docs;

      let maxRef = olabIDsRef;
      let maxArr = olabIDsArray;
      let maxOrderBy = "olab_id";
      // OlabUtils.infoLog("olabIDsArray.length = " + olabIDsArray.length);

      if (nameIDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("nameIDsArray.length = " + nameIDsArray.length);
        maxRef = nameIDsRef;
        maxArr = nameIDsArray;
        maxOrderBy = "name_uc";
      }
      if (creatorIDsArray.length > maxArr.length) {
        // OlabUtils.infoLog("creatorIDsArray.length = " + creatorIDsArray.length);
        maxRef = creatorIDsRef;
        maxArr = creatorIDsArray;
        maxOrderBy = "creator_uc";
      }

      let combinedArray = _.concat(olabIDsArray, nameIDsArray, creatorIDsArray);
      combinedArray = _.uniqWith(combinedArray, _.isEqual);

      const snapArr = [];
      combinedArray.forEach(function(doc) {
        // OlabUtils.infoLog(doc.id + " => " + doc.data());
        snapArr.push(doc.data());
      });
      // Setup Next reference
      if (snapArr.length >= OlabSearch.cntPerPage) {
        selected.collectionRef = maxRef;
        selected.collectionOrderBy = maxOrderBy;
        selected.nextRecRef = snapArr[snapArr.length - 1];
        selected.nextIsDisabled = false;
        OlabUtils.infoLog(
          "selected.nextRecRef.olab_id = " + selected.nextRecRef.olab_id
        );
      }
      OlabUtils.infoLog("snapArr.len = " + snapArr.length);
      selected.items = snapArr;
    } else {
      // Search will be done with uppercase
      let nsTerm = sTerm.toUpperCase();
      let filterField = "olab_id";
      if (sFilter === "name") {
        filterField = "name_uc";
      } else if (sFilter === "creator") {
        filterField = "creator_uc";
      }

      let sTermSA = OlabSearch.searchTermStopAt(nsTerm);
      OlabUtils.infoLog("nsTerm = " + nsTerm + ", sTermSA = " + sTermSA);

      const olabRef = db
        .collectionGroup("olab_carts")
        .where(filterField, ">=", nsTerm)
        .where(filterField, "<", sTermSA);

      olabRef
        .limit(OlabSearch.cntPerPage)
        .withConverter(OlabCart.getOlabCartConverter())
        .get()
        .then(
          function(querySnapshot) {
            const snapArr = [];
            querySnapshot.forEach(function(doc) {
              // OlabUtils.infoLog(doc.id + " => " + doc.data());
              snapArr.push(doc.data());
            });
            if (snapArr.length >= OlabSearch.cntPerPage) {
              selected.collectionRef = olabRef;
              selected.collectionOrderBy = filterField;
              selected.nextRecRef = snapArr[snapArr.length - 1];
              selected.nextIsDisabled = false;
              OlabUtils.infoLog(
                "selected.nextRecRef.olab_id = " + selected.nextRecRef.olab_id
              );
            }
            OlabUtils.infoLog("snapArr.len = " + snapArr.length);
            selected.items = snapArr;
          }.bind(this)
        );
    }
  }

  // XXXX For Update Data to append *_uc fields
  static searchAndUpdateGenesUC(microbeID, strainID, sTerm, sFilter, cnt) {
    // Default search will be done with uppercase
    let nsTerm = sTerm.toUpperCase();
    let filterField = "olab_id";
    if (sFilter === "name") {
      filterField = "name_uc";
    } else if (sFilter === "locus_tag") {
      filterField = "locus_tag";
    } else if (sFilter === "old_locus_tag") {
      filterField = "old_locus_tag_uc";
    } else if (sFilter === "seq") {
      filterField = "sequence.seq";
    }

    let sTermSA = OlabSearch.searchTermStopAt(nsTerm);
    OlabUtils.infoLog("nsTerm = " + nsTerm + ", sTermSA = " + sTermSA);

    let collectionStr =
      "microbes/" + microbeID + "/olab_items/" + strainID + "/olab_genes";

    OlabUtils.infoLog(
      "microbeID = " + microbeID + ", collectionStr = " + collectionStr
    );

    db.collection(collectionStr)
      .where(filterField, ">=", nsTerm)
      .where(filterField, "<", sTermSA)
      .limit(cnt)
      .withConverter(OlabGene.getOlabGeneConverter())
      .get()
      .then(
        function(querySnapshot) {
          const snapArr = [];
          querySnapshot.forEach(function(doc) {
            OlabUtils.infoLog(doc.id + " => " + doc.data());
            snapArr.push(doc.data());
            const item = doc.data();
            if (item.name_uc && item.name_uc != "") {
              OlabUtils.infoLog("item.name_uc = " + item.name_uc);
              item.name_uc = item.name.toUpperCase() + " ^%#- " + item.olab_id;
              OlabUtils.infoLog("-- item.name_uc = " + item.name_uc);
            }
            if (item.creator_uc && item.creator_uc != "") {
              OlabUtils.infoLog("item.creator_uc = " + item.creator_uc);
              item.creator_uc =
                item.creator.toUpperCase() + " ^%#- " + item.olab_id;
              OlabUtils.infoLog("-- item.creator_uc = " + item.creator_uc);
            }

            OlabUtils.infoLog("Update Genes: collectionStr = " + collectionStr);
            db.collection(collectionStr)
              .withConverter(OlabGene.getOlabGeneConverter())
              .doc(item.olab_id)
              .set(item, { merge: true })
              .then(
                function() {
                  OlabUtils.infoLog("Document successfully written!");
                }.bind(this)
              )
              .catch(
                function(error) {
                  OlabUtils.infoLog("Error writing document: " + error);
                  this.error = error;
                }.bind(this)
              );
          });
          OlabUtils.infoLog("snapArr.len = " + snapArr.length);
        }.bind(this)
      );
  }

  static searchAndUpdateCartsUC(sTerm, sFilter, cnt) {
    // Search will be done with uppercase
    let nsTerm = sTerm.toUpperCase();
    let filterField = "olab_id";
    if (sFilter === "name") {
      filterField = "name_uc";
    } else if (sFilter === "creator") {
      filterField = "creator_uc";
    } else if (sFilter === "seq") {
      filterField = "seq";
    }

    let sTermSA = OlabSearch.searchTermStopAt(nsTerm);
    OlabUtils.infoLog("nsTerm = " + nsTerm + ", sTermSA = " + sTermSA);

    const olabRef = db
      .collectionGroup("olab_carts")
      .where(filterField, ">=", nsTerm)
      .where(filterField, "<", sTermSA);

    olabRef
      .limit(cnt)
      .withConverter(OlabCart.getOlabCartConverter())
      .get()
      .then(
        function(querySnapshot) {
          const snapArr = [];
          querySnapshot.forEach(function(doc) {
            OlabUtils.infoLog(doc.id + " => " + doc.data());
            snapArr.push(doc.data());
            const item = doc.data();
            if (item.name_uc && item.name_uc != "") {
              OlabUtils.infoLog("item.name_uc = " + item.name_uc);
              item.name_uc = item.name.toUpperCase() + " ^%#- " + item.olab_id;
              OlabUtils.infoLog("-- item.name_uc = " + item.name_uc);
            }
            if (item.creator_uc && item.creator_uc != "") {
              OlabUtils.infoLog("item.creator_uc = " + item.creator_uc);
              item.creator_uc =
                item.creator.toUpperCase() + " ^%#- " + item.olab_id;
              OlabUtils.infoLog("-- item.creator_uc = " + item.creator_uc);
            }
            var cartsRef =
              "projects/PJ/olab_items/" + item.project_id + "/olab_carts";
            OlabUtils.infoLog("Update Cart: project's carts ref = " + cartsRef);
            db.collection(cartsRef)
              .withConverter(OlabCart.getUpdateCartConverter())
              .doc(item.olab_id)
              .set(item, { merge: true })
              .then(
                function() {
                  OlabUtils.infoLog("Document successfully written!");
                }.bind(this)
              )
              .catch(
                function(error) {
                  OlabUtils.infoLog("Error writing document: " + error);
                  this.error = error;
                }.bind(this)
              );
          });
          OlabUtils.infoLog("snapArr.len = " + snapArr.length);
        }.bind(this)
      );
  }

  static searchAndUpdateProjectsUC(sTerm, sFilter, cnt) {
    // Search will be done with uppercase
    let nsTerm = sTerm.toUpperCase();
    let filterField = "olab_id";
    if (sFilter === "name") {
      filterField = "name_uc";
    } else if (sFilter === "creator") {
      filterField = "creator_uc";
    } else if (sFilter === "seq") {
      filterField = "seq";
    }

    let sTermSA = OlabSearch.searchTermStopAt(nsTerm);
    OlabUtils.infoLog("nsTerm = " + nsTerm + ", sTermSA = " + sTermSA);

    const olabRef = db
      .collectionGroup("olab_items")
      .where("olab_type", "==", "project")
      .where(filterField, ">=", nsTerm)
      .where(filterField, "<", sTermSA);

    olabRef
      .limit(cnt)
      .withConverter(OlabItem.getOlabItemConverter())
      .get()
      .then(
        function(querySnapshot) {
          const snapArr = [];
          querySnapshot.forEach(function(doc) {
            OlabUtils.infoLog(doc.id + " => " + doc.data());
            snapArr.push(doc.data());
            const item = doc.data();
            if (item.name_uc && item.name_uc != "") {
              OlabUtils.infoLog("item.name_uc = " + item.name_uc);
              item.name_uc = item.name.toUpperCase() + " ^%#- " + item.olab_id;
              OlabUtils.infoLog("-- item.name_uc = " + item.name_uc);
            }
            if (item.creator_uc && item.creator_uc != "") {
              OlabUtils.infoLog("item.creator_uc = " + item.creator_uc);
              item.creator_uc =
                item.creator.toUpperCase() + " ^%#- " + item.olab_id;
              OlabUtils.infoLog("-- item.creator_uc = " + item.creator_uc);
            }
            const projRef = "projects/PJ/olab_items";
            OlabUtils.infoLog("Update Project: projects ref = " + projRef);
            db.collection(projRef)
              .withConverter(OlabProject.getUpdateItemConverter())
              .doc(item.olab_id)
              .set(item, { merge: true })
              .then(
                function() {
                  OlabUtils.infoLog("Document successfully written!");
                }.bind(this)
              )
              .catch(
                function(error) {
                  OlabUtils.infoLog("Error writing document: " + error);
                  this.error = error;
                }.bind(this)
              );
          });
          OlabUtils.infoLog("snapArr.len = " + snapArr.length);
        }.bind(this)
      );
  }

  static searchAndUpdatePackagesUC(sTerm, sFilter, cnt) {
    // Search will be done with uppercase
    let nsTerm = sTerm.toUpperCase();
    let filterField = "olab_id";
    if (sFilter === "name") {
      filterField = "name_uc";
    } else if (sFilter === "creator") {
      filterField = "creator_uc";
    } else if (sFilter === "seq") {
      filterField = "seq";
    }

    let sTermSA = OlabSearch.searchTermStopAt(nsTerm);
    OlabUtils.infoLog("nsTerm = " + nsTerm + ", sTermSA = " + sTermSA);

    const olabRef = db
      .collectionGroup("olab_items")
      .where("olab_type", "==", "package")
      .where(filterField, ">=", nsTerm)
      .where(filterField, "<", sTermSA);

    olabRef
      .limit(cnt)
      .withConverter(OlabItem.getOlabItemConverter())
      .get()
      .then(
        function(querySnapshot) {
          const snapArr = [];
          querySnapshot.forEach(function(doc) {
            OlabUtils.infoLog(doc.id + " => " + doc.data());
            snapArr.push(doc.data());
            const item = doc.data();
            if (item.name_uc && item.name_uc != "") {
              OlabUtils.infoLog("item.name_uc = " + item.name_uc);
              item.name_uc = item.name.toUpperCase() + " ^%#- " + item.olab_id;
              OlabUtils.infoLog("-- item.name_uc = " + item.name_uc);
            }
            if (item.creator_uc && item.creator_uc != "") {
              OlabUtils.infoLog("item.creator_uc = " + item.creator_uc);
              item.creator_uc =
                item.creator.toUpperCase() + " ^%#- " + item.olab_id;
              OlabUtils.infoLog("-- item.creator_uc = " + item.creator_uc);
            }
            const pkgsRef = "packages/PG/olab_items";
            OlabUtils.infoLog("Update Package: packages ref = " + pkgsRef);
            db.collection(pkgsRef)
              .withConverter(OlabPackage.getUpdatePackageConverter())
              .doc(item.olab_id)
              .set(item, { merge: true })
              .then(
                function() {
                  OlabUtils.infoLog("Document successfully written!");
                }.bind(this)
              )
              .catch(
                function(error) {
                  OlabUtils.infoLog("Error writing document: " + error);
                  this.error = error;
                }.bind(this)
              );
          });
          OlabUtils.infoLog("snapArr.len = " + snapArr.length);
        }.bind(this)
      );
  }

  static searchAndUpdateSequencesUC(sTerm, sFilter, cnt) {
    // Search will be done with uppercase
    let nsTerm = sTerm.toUpperCase();
    let filterField = "olab_id";
    if (sFilter === "name") {
      filterField = "name_uc";
    } else if (sFilter === "creator") {
      filterField = "creator_uc";
    } else if (sFilter === "seq") {
      filterField = "seq";
    }

    let sTermSA = OlabSearch.searchTermStopAt(nsTerm);
    OlabUtils.infoLog("nsTerm = " + nsTerm + ", sTermSA = " + sTermSA);

    const olabRef = db
      .collectionGroup("olab_items")
      .where("olab_type", "==", "library_sequence")
      .where(filterField, ">=", nsTerm)
      .where(filterField, "<", sTermSA);

    olabRef
      .limit(cnt)
      .withConverter(OlabItem.getOlabItemConverter())
      .get()
      .then(
        function(querySnapshot) {
          const snapArr = [];
          querySnapshot.forEach(function(doc) {
            OlabUtils.infoLog(doc.id + " => " + doc.data());
            snapArr.push(doc.data());
            const item = doc.data();
            if (item.name_uc && item.name_uc != "") {
              OlabUtils.infoLog("item.name_uc = " + item.name_uc);
              item.name_uc = item.name.toUpperCase() + " ^%#- " + item.olab_id;
              OlabUtils.infoLog("-- item.name_uc = " + item.name_uc);
            }
            if (item.creator_uc && item.creator_uc != "") {
              OlabUtils.infoLog("item.creator_uc = " + item.creator_uc);
              item.creator_uc =
                item.creator.toUpperCase() + " ^%#- " + item.olab_id;
              OlabUtils.infoLog("-- item.creator_uc = " + item.creator_uc);
            }
            db.collection("libraries")
              .doc(item.library_id)
              .collection("olab_items")
              .withConverter(OlabSequence.getUpdateItemConverter())
              .doc(item.olab_id)
              .set(item, { merge: true })
              .then(
                function() {
                  OlabUtils.infoLog("Document successfully written!");
                }.bind(this)
              )
              .catch(
                function(error) {
                  OlabUtils.infoLog("Error writing document: " + error);
                  this.error = error;
                }.bind(this)
              );
          });
          OlabUtils.infoLog("snapArr.len = " + snapArr.length);
        }.bind(this)
      );
  }

  static infoLog(srch) {
    OlabUtils.infoLog("srch.sTerm = " + srch.sTerm);
    OlabUtils.infoLog("srch.sTermStopAt = " + srch.sTermStopAt);
  }
}

export { OlabSearch };
